<template>
<div class="form">
  <v-card style="margin-top: 250px">
          <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          <h1 align="center" style="text-decoration: underline overline;">JRB - PINDAHAN SEMASA DITERIMA</h1>

          <v-text-field
            outlined 
            dense
            rounded
            v-model="HID"
            label="HID"
            :rules="rules"
            width="20px"
            disabled
          ></v-text-field>
          
        <!-- DATATABLE  -->
        <v-card  color="rgba(217, 217, 217, 0.5)" class="mb-5">
              <v-card-title>
                  Senarai
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="dataJRBpindahan"
                :search="search"
                class="ml-3 mr-3"
                @click:row="handleClick"
                :footer-props="{'items-per-page-options':[3,15, 30, 50, 100, -1]}"
              >
              <template v-slot:item.INCS41a= "{ item }">
                 {{ formatNumber(item.INCS41a) }}
              </template> 
              <template v-slot:item.INCS41b= "{ item }">
                {{ formatNumber(item.INCS41b) }}
              </template> 
              <template v-slot:item.INCS41= "{ item }">
                {{ formatNumber(item.INCS41) }}
              </template> 
              <template v-slot:item.INCS42= "{ item }">
                {{ formatNumber(item.INCS42) }}
              </template> 
              <template v-slot:item.INCS43= "{ item }">
                {{ formatNumber(item.INCS43) }}
              </template> 
              <template v-slot:item.INCS44= "{ item }">
                {{ formatNumber(item.INCS44) }}
              </template> 
              <template v-slot:item.INCS45a= "{ item }">
                {{ formatNumber(item.INCS45a) }}
              </template> 
              <template v-slot:item.INCS45b= "{ item }">
                {{ formatNumber(item.INCS45b) }}
              </template> 
              <template v-slot:item.INCS45c= "{ item }">
                {{ formatNumber(item.INCS45c) }}
              </template> 
              <template v-slot:item.INCS45d= "{ item }">
                {{ formatNumber(item.INCS45d) }}
              </template> 
              <template v-slot:item.INCS45e= "{ item }">
                {{ formatNumber(item.INCS45e) }}
              </template> 
              <template v-slot:item.INCS45f= "{ item }">
                {{ formatNumber(item.INCS45f) }}
              </template> 
              <template v-slot:item.INCS45g= "{ item }">
                {{ formatNumber(item.INCS45g) }}
              </template> 
              <template v-slot:item.INCS45h= "{ item }">
                {{ formatNumber(item.INCS45h) }}
              </template> 
              <template v-slot:item.INCS45i= "{ item }">
                {{ formatNumber(item.INCS45i) }}
              </template> 
              <template v-slot:item.INCS45j= "{ item }">
                {{ formatNumber(item.INCS45j) }}
              </template>
              <template v-slot:item.INCS45k= "{ item }">
                {{ formatNumber(item.INCS45k) }}
              </template>
              <template v-slot:item.INCS45l= "{ item }">
                {{ formatNumber(item.INCS45l) }}
              </template>
              <template v-slot:item.INCS45m= "{ item }">
                {{ formatNumber(item.INCS45m) }}
              </template>
              <template v-slot:item.INCS45= "{ item }">
                {{ formatNumber(item.INCS45) }}
              </template>
              <template v-slot:item.INCS46a_i= "{ item }">
                {{ formatNumber(item.INCS46a_i) }}
              </template>
              <template v-slot:item.INCS46a_ii= "{ item }">
                {{ formatNumber(item.INCS46a_ii) }}
              </template>
              <template v-slot:item.INCS46a= "{ item }">
                {{ formatNumber(item.INCS46a) }}
              </template>
              <template v-slot:item.INCS46b= "{ item }">
                {{ formatNumber(item.INCS46b) }}
              </template>
              <template v-slot:item.INCS46c= "{ item }">
                {{ formatNumber(item.INCS46c) }}
              </template>
              <template v-slot:item.INCS46d_i= "{ item }">
                {{ formatNumber(item.INCS46d_i) }}
              </template>
              <template v-slot:item.INCS46d_ii= "{ item }">
                {{ formatNumber(item.INCS46d_ii) }}
              </template>
              <template v-slot:item.INCS46d= "{ item }">
                {{ formatNumber(item.INCS46d) }}
              </template>
              <template v-slot:item.INCS46e= "{ item }">
                {{ formatNumber(item.INCS46e) }}
              </template>
              <template v-slot:item.INCS46f= "{ item }">
                {{ formatNumber(item.INCS46f) }}
              </template>
              <template v-slot:item.INCS46= "{ item }">
                {{ formatNumber(item.INCS46) }}
              </template>
              <template v-slot:item.INCS05= "{ item }">
                {{ formatNumber(item.INCS05) }}
              </template>
       </v-data-table>
      </v-card>   
    </v-card>   

<v-card>
  <v-card-title>
    Pendapatan lain diperoleh
  </v-card-title>

  <v-card-text>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >

      <!-- S99 -->
        <v-col>
          S99 : Kiriman wang yang diterima dari isi rumah lain 
          <v-row>
              <v-col cols="4" sm="6" md="4">
                (i) Dalam negara (Setahun) <strong>[INCS41a]</strong>
                <v-text-field
                      v-model="INCS41a"
                      label="RM"
                      outlined
                      type="number"
                      dense
                       style="width: 300px"
                       @keypress="limitDigits"
                ></v-text-field>
              </v-col>

              <v-col cols="4" sm="6" md="4">
                (ii) Luar negara (Setahun) <strong>[INCS41b]</strong>
                 <v-text-field
                      v-model="INCS41b"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                      @keypress="limitDigits"
                ></v-text-field>
              </v-col>
               <v-col cols="4" sm="6" md="4">
                Jumlah kiriman wang yang diterima dari isi rumah lain <strong>[INCS41]</strong>
                <!-- s94i+s94ii+s94iii -->
                <v-text-field
                      v-model="INCS41"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      disabled
                      style="width: 300px"
                ></v-text-field>
              </v-col>
              
          </v-row>
        </v-col>

      <v-row>
        <v-col>
          S100 : Nafkah (Setahun) <strong>[INCS42]</strong>
         <!-- incs22_2 - incs22_3 -->
          <v-row>
            <v-col cols="4" sm="6" md="4">
            <v-text-field
                      v-model="INCS42"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                      @keypress="limitDigits"
                ></v-text-field>
                 </v-col>
            </v-row>
        </v-col>
      </v-row>
      <!-- s101 -->
    <v-row>
        <v-col>
          S101 : Biasiswa/Dermasiswa/Fellowship (Setahun) <strong>[INCS43]</strong>
       
          <v-row>
            <v-col cols="4" sm="6" md="4">
            <v-text-field
                      v-model="INCS43"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                      @keypress="limitDigits"
             ></v-text-field>
             </v-col>
            </v-row>
        </v-col>
      </v-row> 
      <v-row>
        <v-col>
          S102 : Pencen (Setahun) <strong>[INCS44]</strong>
       
          <v-row>
            <v-col cols="4" sm="6" md="4">
            <v-text-field
                      v-model="INCS44"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                      @keypress="limitDigits"
             ></v-text-field>
             </v-col>
            </v-row>
        </v-col>
      </v-row> 
       <!-- s103 -->
      <v-row>
        <v-col>
         S103 : Pembayaran lain berkala yang diterima 
          <v-row>
              <v-col cols="4" sm="6" md="4">
                (i) Elaun yang diterima oleh kerabat diraja (Setahun) <strong>[INCS45a]</strong>
                <v-text-field
                      v-model="INCS45a"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                      @keypress="limitDigits"
                ></v-text-field>
              </v-col>

              <v-col cols="4" sm="6" md="4">
                (ii) Bantuan diterima secara bulanan daripada Jabatan Kebajikan Masyarakat dan/atau agensi kerajaan lain secara berkala (Setahun) <strong>[INCS45b]</strong>
                 <v-text-field
                      v-model="INCS45b"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="6" md="4">
                (iii)  Penerimaan wang secara berkala daripada harta pusaka atau tabung wang amanah (Setahun) <strong>[INCS45c]</strong>
                 <v-text-field
                      v-model="INCS45c"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                ></v-text-field>
               
              </v-col>
               <v-col cols="4" sm="6" md="4"> 
                (iv) Pembayaran insurans diterima secara berkala disebabkan oleh kecederaan (Setahun) <strong>[INCS45d]</strong>
                 <v-text-field
                      v-model="INCS45d"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                ></v-text-field>
               
              </v-col>
               <v-col cols="4" sm="6" md="4">
                (v) Pampasan diberikan oleh majikan kepada pekerja disebabkan kecacatan akibat kemalangan semasa bekerja. Pembayaran diberi secara berkala setiap bulan berbentuk wang tunai (Setahun) <strong>[INCS45e]</strong>
                 <v-text-field
                      v-model="INCS45e"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                ></v-text-field>
               
              </v-col>
              <v-col cols="4" sm="6" md="4">
                (vi) Elaun yang diterima oleh imam, bilal dan siak yang dibayar bawah peruntukan masjid (Setahun) <strong>[INCS45f]</strong>
                 <v-text-field
                      v-model="INCS45f"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                ></v-text-field>
               
              </v-col>
              <v-col cols="4" sm="6" md="4">
                (vii) Elaun yang diterima oleh sami/paderi yang dibayar oleh rumah ibadat (Setahun) <strong>[INCS45g]</strong>
                 <v-text-field
                      v-model="INCS45g"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="6" md="4">
                (viii) Elaun bulanan ahli sukan (bukan profesional) yang diterima daripada Majlis Sukan Negara (Setahun) <strong>[INCS45h]</strong>
                 <v-text-field
                      v-model="INCS45h"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="6" md="4">
                (ix) Lain-lain elaun (Setahun) (cth: Undang; Kumpulan Wang Amanah; dll) <strong>[INCS45i]</strong>
                 <v-text-field
                      v-model="INCS45i"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="6" md="4">
               (x) Sumbangan Tunai Rahmah (STR)<strong>[INCS45j]</strong>
                 <v-text-field
                      v-model="INCS45j"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="6" md="4">
               (xi) Bantuan persekolahan <strong>[INCS45k]</strong>
                 <v-text-field
                      v-model="INCS45k"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="6" md="4">
               (xii) Sumbangan Asas Rahmah (SARA) <strong>[INCS45l]</strong>
                 <v-text-field
                      v-model="INCS45l"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="6" md="4">
               (xiii) Penerimaan zakat secara berkala daripada Majlis Agama Islam Negeri <strong>[INCS45m]</strong>
                 <v-text-field
                      v-model="INCS45m"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="6" md="4">
               Jumlah pembayaran lain berkala yang diterima <strong>[INCS45]</strong>
                <!-- s84i+s84ii+s84iii -->
                <v-text-field
                      v-model="INCS45"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      disabled
                      style="width: 300px"
                ></v-text-field>
               
              </v-col>
          </v-row>
        </v-col>
      </v-row>
       <!-- s104 -->
      <v-row>
        <v-col>
           S104 : Hadiah berupa wang tunai 
          <v-row>
              <v-col cols="4" sm="6" md="4">
                (i) Kerajaan Persekutuan (Setahun) <strong>[INCS46a(i)]</strong>
                <v-text-field
                      v-model="INCS46a_i"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                ></v-text-field>
              </v-col>

              <v-col cols="4" sm="6" md="4">
                (ii) Kerajaan Negeri (Setahun) <strong>[INCS46a(ii)]</strong>
                 <v-text-field
                      v-model="INCS46a_ii" 
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                ></v-text-field>
              </v-col>
              
              <v-col cols="4" sm="6" md="4">
                 Jumlah hadiah berupa wang tunai dari Kerajaan <strong>[INCS46a]</strong>
                <!-- s90i+s90ii -->
                <v-text-field
                      v-model="INCS46a"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      disabled
                      style="width: 300px"
                ></v-text-field>
                </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- s91 -->
      <v-row>
        <v-col>
          S105 : Hadiah berupa wang tunai dari NGO/Swasta <strong>[INCS46b]</strong>
         <!-- incs32a_1 - incs32a_2 -->
          <v-row>
            <v-col cols="4" sm="6" md="4">
            <v-text-field
                      v-model="INCS46b"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                ></v-text-field>
                 </v-col>
            </v-row>
        </v-col>
      </v-row> 
       <v-row>
        <v-col>
          S106 : Hadiah berupa wang tunai dari individu <strong>[INCS46c]</strong>
         <!-- incs32b_1 - incs32b_2 -->
          <v-row>
            <v-col cols="4" sm="6" md="4">
            <v-text-field
                      v-model="INCS46c"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
             ></v-text-field>
             </v-col>
            </v-row>
        </v-col>
      </v-row> 
     
       <!-- s94 -->
      <v-row>
        <v-col>
         S107 : Hadiah berupa mata bentuk
          <v-row>
              <v-col cols="4" sm="6" md="4">
                (i) Kerajaan Persekutuan (Setahun) <strong>[INCS46d(i)]</strong>
                <v-text-field
                      v-model="INCS46d_i"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                ></v-text-field>
              </v-col>

              <v-col cols="4" sm="6" md="4">
                (ii) Kerajaan Negeri (Setahun)  <strong>[INCS46d(ii)]</strong>
                 <v-text-field
                      v-model="INCS46d_ii"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="6" md="4"> 
                Jumlah hadiah berupa wang tunai dari Kerajaan  <strong>[INCS46d]</strong>
                <!-- s94i+s94ii+s94iii -->
                <v-text-field
                      v-model="INCS46d"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      disabled
                      style="width: 300px"
                ></v-text-field>
              </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
         
          <v-row>
              <v-col cols="4" sm="6" md="4">
                S108 : Hadiah berupa mata benda dari NGO/Swasta  <strong>[INCS46e]</strong>
                <v-text-field
                      v-model="INCS46e"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                ></v-text-field>
              </v-col>

              <v-col cols="4" sm="6" md="4">
                S109 : Hadiah berupa mata benda dari individu  <strong>[INCS46f]</strong>
                 <v-text-field
                      v-model="INCS46f"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 300px"
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="6" md="4">
               S110 : Jumlah hadiah wang tunai/mata benda (Setahun)  <strong>[INCS46]</strong>
                <!-- s94i+s94ii+s94iii -->
                <v-text-field
                      v-model="INCS46"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      disabled
                      style="width: 300px"
                ></v-text-field>
              </v-col>
          </v-row>
        </v-col>
      </v-row>
        <v-row>
        <v-col> 
          <v-row>
              <v-col cols="4" sm="6" md="4">
                S111 : Jumlah pindahan semasa diterima (Setahun)  <strong>[INCS05]</strong>
                <v-text-field
                      v-model="INCS05"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      disabled
                      style="width: 300px"
                ></v-text-field>
              </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </v-card-text>

<v-card-actions>
 <v-spacer></v-spacer>
   <v-btn
        text
        color="primary"
        @click='simpan()'
        v-show="butangSimpan"
    >
      Simpan
    </v-btn>
    <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="updateJRBpindahan()"
    >
      Simpan/Kemaskini
    </v-btn>
     <!-- <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="goTo('2')"
    >
      Seterusnya
    </v-btn> -->
</v-card-actions>
</v-card>

<!-- Error Dialog -->
<v-dialog
      v-model="errorDialog"
      width="500"
      height="200"
    >
    <v-card>
      <v-alert
        dense
        outlined
        color="#C51162"
        type="error"
      >
      <strong>{{errMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Success Dialog -->
<v-dialog
      v-model="successDialog"
      width="500"
      height="200"
    >
    <v-card
    color="success"
    >
      <v-alert
        dense
        outlined
        color="#C51162"
        type="success"
      >
      <strong>{{successMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Success Dialog -->
<v-dialog
      v-model="successDialog"
      width="500"
      height="200"
    >
    <v-card
    color="success"
    >
      <v-alert
        dense
        outlined
        color="#C51162"
        type="success"
      >
      <strong>{{successMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>

</div>
</template>
<script>
import axios from 'axios'
import schemeRule from '../../utils/scheme'
//////////////////////////import services///////////////////
import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage(); 

import lookupField from '@/services/lookupField'
const lookupFieldServices = new lookupField();
//////////////////////////end import services//////////////

export default {
    // props:['data'],
    async beforeMount(){
        //this.getUnits('ayam')
        var dataHID = localStorageData.getHIDdata()

        this.HID = dataHID.HID;
        this.BNO = dataHID.BNO;
        this.Ps = dataHID.P;
        this.S = dataHID.S;
        this.NG = dataHID.NG;
        this.DP = dataHID.DP;
        this.DB =  dataHID.DB;
        this.BP = dataHID.BP;
        this.ST = dataHID.ST;
        this.NOTK = dataHID.NOTK;
        this.NOIR = dataHID.NOIR;
        this.Bulan = dataHID.BULAN;
        this.Tahun = dataHID.TAHUN;

        this.masco = await lookupFieldServices.getMasco(); //dapatkan lookup masco
        this.msic = await lookupFieldServices.getMsic(); //dapatkan lookup msic
        this.yaTidak = lookupFieldServices.getYaTidak();
        this.JenisRumah = lookupFieldServices.getJenisRumah();

        this.currNOAIRData = localStorageData.getCurrentNOAIRData();//dapatkan NOAIR yang di click dari page depan
        this.NOAIR = this.currNOAIRData.NOAIR;
        
        //this.getTP73()
        // this.getINCS06()
        this.getData();//dapatkan data based on HID


    },
    setup() {
        
    },
    data: () => ({
       updateButton: true,
        saveButton: false,
        butangSimpan: true,
        butangKemaskini: false,
        dialog: false,
        successDialog: false,
        errorDialog: false,
        successMessage:'',
        errMessage:'',
        message: "Saving Data",
        popUpALert:false,
        kemaskiniDialog: false,
        //dialogPengesahan:false,
        search: '',
        currNOAIRData:'',
        masco:[],
        msic:[],
        yaTidak:[],
        JenisRumah:[],
        showS76 : false,
        showS81 : false,
        showS87 : false,
        showS89 : false,
        showS93 : false,
        /////////////////////data declaration//////////////////////////
        HID: '',
        KAW: 1,
        Bulan:'',
        Tahun:'',
        BNO:'',
        Ps:'',
        S:'',
        NG: '',
        DP:'',
        DB:'',
        BP:'',
        ST:'',
        NOTK:'',
        NOIR:'',
        R:1,
        NOAIR:'',
        INCS41a:0,
        INCS41b:0,
        //INCS41:0,
        INCS42:0,
        INCS43:0,
        INCS44:0,
        INCS45a:0,
        INCS45b:0,
        INCS45c:0,
        INCS45d:0,
        INCS45e:0,
        INCS45f:0,
        INCS45g:0,
        INCS45h:0,
        INCS45i:0,
        INCS45j:0,
        INCS45k:0,
        INCS45l:0,
        INCS45m:0,
        //INCS45:0,
        INCS46a_i:0,
        INCS46a_ii:0,
        //INCS46a:0,
        INCS46b:0,
        INCS46c:0,
        INCS46d_i:0,
        INCS46d_ii:0,
        //INCS46d:0,
        INCS46e:0,
        INCS46f:0,
        //INCS46:0,
        //INCS05:0,
        INCS06:0,
        dataJRBpindahan:[],


        
        rules: [
        value => !!value || 'Required.',
        ],
        headers: [
          {
            text: 'NOAIR',
            align: 'start',
            sortable: false,
            value: 'NOAIR',
          },
          { text: 'HID', value: 'HID' },
          { text: 'INCS41a', value: 'INCS41a' },
          { text: 'INCS41b', value: 'INCS41b' },
          { text: 'INCS41', value: 'INCS41' },
          { text: 'INCS42', value: 'INCS42' },
          { text: 'INCS43', value: 'INCS43' },
          { text: 'INCS44', value: 'INCS44' },
          { text: 'INCS45a', value: 'INCS45a' },
          { text: 'INCS45b', value: 'INCS45b' },
          { text: 'INCS45c', value: 'INCS45c' },
          { text: 'INCS45d', value: 'INCS45d' },
          { text: 'INCS45e', value: 'INCS45e' },
          { text: 'INCS45f', value: 'INCS45f' },
          { text: 'INCS45g', value: 'INCS45g' },
          { text: 'INCS45h', value: 'INCS45h' },
          { text: 'INCS45i', value: 'INCS45i' },
          { text: 'INCS45j', value: 'INCS45j' },
          { text: 'INCS45k', value: 'INCS45k' },
          { text: 'INCS45l', value: 'INCS45l' },
          { text: 'INCS45m', value: 'INCS45m' },
          { text: 'INCS45', value: 'INCS45' },
          { text: 'INCS46a(i)', value: 'INCS46a_i' },
          { text: 'INCS46a(ii)', value: 'INCS46a_ii' },
          { text: 'INCS46a', value: 'INCS46a' },
          { text: 'INCS46b', value: 'INCS46b' },
          { text: 'INCS46c', value: 'INCS46c' },
          { text: 'INCS46d(i)', value: 'INCS46d_i' },
          { text: 'INCS46d(ii)', value: 'INCS46d_ii' },
          { text: 'INCS46d', value: 'INCS46d' },
          { text: 'INCS46e', value: 'INCS46e' },
          { text: 'INCS46f', value: 'INCS46f' },
          { text: 'INCS46', value: 'INCS46' },
          { text: 'INCS05', value: 'INCS05' },
          // { text: 'INCS06', value: 'INCS06' },
          // { text: 'TP73', value: 'TP73' },
          
          
          //{ text: 'HKI Pendapatan', value: 'PENHK1' },
        ],
       ///////////link untuk ke page/////////////////////
      breadcrumbs: [
        {
          text: 'Status Pengisian',
          disabled: false,
          href: 'ringkasanMaklumatIR',
        },
        {
          text: 'JRB Pindahan Semasa Diterima',
          disabled: true,
          href: 'JRBpindahan',
        },
        // {
        //   text: 'JRB Penerimaan Bulan Sebelumnya',
        //   disabled: false,
        //   href: 'IMBANGAN',
        // },
        //   {
        //   text: 'JRB Penerimaan one-off',
        //   disabled: false,
        //   href: 'JRB1off',
        // },
        //   {
        //   text: 'JRC Pindahan Semasa Dibayar',
        //   disabled: false,
        //   href: 'JRCPSD',
        // },
        //   {
        //   text: 'JRD Pinjaman Kewangan',
        //   disabled: false,
        //   href: 'JRD',
        // },
        
      ],
      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      select: null,
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4',
      ],
      checkbox: false,
    }),

    methods: {
      formatNumber(value) {
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      stripCommas(value) {
      return value.replace(/,/g, '');
      },
      getUnits: function(a) {
            alert(`${a}`)
      },
      validate () {
        this.$refs.form.validate()
      },
      limitDigits(event) {
        const value = event.target.value;
        if (value.length >= 8) {
            event.preventDefault();
        }
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      changeS75(val){
        var valueS75 = val.id;
        if(valueS75 == 1){
          this.showS76 = true;
        }
        if(valueS75 == 2){
          this.showS76 = false;
        }

      },
      changeS80(val){
        var valueS80 = val.id;
        if(valueS80 == 1){
          this.showS81 = true;
        }
        if(valueS80 == 2){
          this.showS81 = false;
        }

      },
      changeS86(val){
        var valueS86 = val.id;
        if(valueS86 == 1){
          this.showS87 = true;
        }
        if(valueS86 == 2){
          this.showS87 = false;
        }

      },
      changeS88(val){
        var valueS88 = val.id;
        if(valueS88 == 1){
          this.showS89 = true;
        }
        if(valueS88 == 2){
          this.showS89 = false;
        }

      },
      changeS92(val){
        var valueS92 = val.id;
        if(valueS92 == 1){
          this.showS93 = true;
        }
        if(valueS92 == 2){
          this.showS93 = false;
        }
        

      },
      //  goTo(){
      //     this.$router.push({name: "JRB1off"});
      // },
      
      async simpan (){
        // alert(this.HID)
        // alert(this.NOAIR)
        if (this.$refs.form.validate()){
            this.dialog =  true;
            setTimeout(() => (this.dialog = false), 2000)
         
            try {

                //const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/HK1`, {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/JR5/JRBpindahan`, {
                
                HID:  this.HID,
                NOAIR: this.NOAIR,
                INCS41a: this.INCS41a, 
                INCS41b: this.INCS41b,
                INCS41: this.INCS41,
                INCS42: this.INCS42,
                INCS43: this.INCS43,
                INCS44: this.INCS44,
                INCS45a: this.INCS45a,
                INCS45b: this.INCS45b,
                INCS45c: this.INCS45c,
                INCS45d: this.INCS45d,
                INCS45e: this.INCS45e,
                INCS45f: this.INCS45f,
                INCS45g: this.INCS45g,
                INCS45h: this.INCS45h, 
                INCS45i: this.INCS45i,
                INCS45j: this.INCS45j,
                INCS45k: this.INCS45k,
                INCS45l: this.INCS45l,
                INCS45m: this.INCS45m,
                INCS45: this.INCS45,
                INCS46a_i: this.INCS46a_i,
                INCS46a_ii: this.INCS46a_ii,
                INCS46a: this.INCS46a,
                INCS46b: this.INCS46b,
                INCS46c: this.INCS46c,
                INCS46d_i: this.INCS46d_i,
                INCS46d_ii: this.INCS46d_ii,
                INCS46d: this.INCS46d,
                INCS46e: this.INCS46e,
                INCS46f: this.INCS46f,
                INCS46: this.INCS46,
                INCS05: this.INCS05,
                // INCS06: this.INCS06,
              })
                this.res = res.data
                this.successDialog = true;
                setTimeout(() => (this.successDialog = false), 2000);
                this.successMessage = 'Data Disimpan!';
                this.reset();
                this.getData();
                setTimeout(() => (this.goTo()), 1000);
                
            } catch (error) {
              
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }
        }else{
          window.scrollTo(0, 0);
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'Please fill in the field!';
        }
      },

       async updateJRBpindahan(){
    
            try {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/JR5/updateJRBpindahan`, {
                
                 HID:  this.HID,
                NOAIR: this.NOAIR,
                INCS41a: this.INCS41a, 
                INCS41b: this.INCS41b,
                INCS41: this.INCS41,
                INCS42: this.INCS42,
                INCS43: this.INCS43,
                INCS44: this.INCS44,
                INCS45a: this.INCS45a,
                INCS45b: this.INCS45b,
                INCS45c: this.INCS45c,
                INCS45d: this.INCS45d,
                INCS45e: this.INCS45e,
                INCS45f: this.INCS45f,
                INCS45g: this.INCS45g,
                INCS45h: this.INCS45h, 
                INCS45i: this.INCS45i,
                INCS45j: this.INCS45j,
                INCS45k: this.INCS45k,
                INCS45l: this.INCS45l,
                INCS45m: this.INCS45m,
                INCS45: this.INCS45,
                INCS46a_i: this.INCS46a_i,
                INCS46a_ii: this.INCS46a_ii,
                INCS46a: this.INCS46a,
                INCS46b: this.INCS46b,
                INCS46c: this.INCS46c,
                INCS46d_i: this.INCS46d_i,
                INCS46d_ii: this.INCS46d_ii,
                INCS46d: this.INCS46d,
                INCS46e: this.INCS46e,
                INCS46f: this.INCS46f,
                INCS46: this.INCS46,
                INCS05: this.INCS05,
                // INCS06: this.INCS06,

              })
                this.res = res.data;
                this.reset();
                this.getData();
                this.butangKemaskini = false;
                this.successMessage = 'Data Dikemaskini!';
                this.successDialog = true;
                window.scrollTo(0, 0);
                // this.butangKemaskini = false;
                // this.successDialog = true;
                // setTimeout(() => (this.successDialog = false), 2000);
                // this.successMessage = 'Data Dikemaskini!';
                // this.reset();
                // this.getData();
                // window.scrollTo(0, 0);
                //setTimeout(() => (this.goTo()), 1000);
                
            } catch (error) {
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Kemaskini : '+error;
            }  
      },

      async padam(val){
        if(val == 0){
          this.popUpALert = true; 
        }
        else if(val == 1){
          
          try {
              ///////////tunjukkan alert padam////////////
              this.popUpALert = false;
                ////send delete to API///////
              if (this.$refs.form.validate()){
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/JR5/JRBpindahan/delete`, {
                HID:  this.HID,
                NOAIR: this.NOAIR,
              })
                this.res = res.data
                this.successDialog = true;
                setTimeout(() => (this.successDialog = false), 2000);
                this.successMessage = 'Data Deleted!'
                this.saveButton = false;
                this.updateButton = true;
                this.reset();
                this.getData(); 
              }else{
                this.errorDialog = true;
                setTimeout(() => (this.errorDialog = false), 2000);
                this.errMessage = "Please Fill In the field"
              }
              
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Padam : '+error;
            }
        }
        else if(val == 2){
          this.popUpALert = false;
        }
          
      },
      async getData(){
        //dapatkan data dari table HK1 based on HID
   
        try {
            const res = await axios.get(`${process.env.VUE_APP_API_URL}/JR5/TestJRBpindahan?HID=`+this.HID+`&NOAIR=`+this.NOAIR, {
            })
            var dataz = res.data.data
            this.dataJRBpindahan = dataz;
            console.log(res)
          } catch (error) {
            //console.log(error)
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'getData : '+ error;
          }
      },
      // async getTP73(){
      //   try {
      //       const res = await axios.get(`${process.env.VUE_APP_API_URL}/JR5/getTP73?HID=`+this.HID+`&NOAIR=`+this.NOAIR, {
      
      //       })
      //       var dataz = res.data.data
            
      //       this.TP73 = Number(dataz[0].TP73);
            
      //       console.log(this.TP73)

      //     } catch (error) {
      //       //console.log(error)
      //       this.errorDialog = true;
      //       setTimeout(() => (this.errorDialog = false), 2000);
      //       this.errMessage = 'getData : '+ error;
      //     }
      // },
      // async getINCS06(){
      //   try {
      //       const res = await axios.get(`${process.env.VUE_APP_API_URL}/JR5/getINCS06?HID=`+this.HID+`&NOAIR=`+this.NOAIR, {
      
      //       })
      //       var dataz = res.data.data
            
      //       this.INCS06 = Number(dataz[0].INCS06);
      //       console.log(this.INCS06)

      //     } catch (error) {
      //       //console.log(error)
      //       this.errorDialog = true;
      //       setTimeout(() => (this.errorDialog = false), 2000);
      //       this.errMessage = 'getData : '+ error;
      //     }
      // },
      handleClick(row) {
        console.log('Row clicked:', row);
        
          this.successDialog = true;
          this.successMessage = "Sila mulakan pengemaskinian!";
          this.butangKemaskini = true; 

          this.saveButton = true;
          this.updateButton = false;
          this.butangKemaskini = true;
          this.butangSimpan = false;
          this.NOAIR = row.NOAIR;
          this.HID = row.HID;
          this.Bil = row.Bil;
          this.INCS41a = this.stripCommas(row.INCS41a);
          this.INCS41b = this.stripCommas(row.INCS41b);
          this.INCS41 = this.stripCommas(row.INCS41);
          this.INCS42 = this.stripCommas(row.INCS42);
          this.INCS43 = this.stripCommas(row.INCS43);
          this.INCS44 = this.stripCommas(row.INCS44);
          this.INCS45a = this.stripCommas(row.INCS45a);
          this.INCS45b = this.stripCommas(row.INCS45b);
          this.INCS45c = this.stripCommas(row.INCS45c);
          this.INCS45d = this.stripCommas(row.INCS45d);
          this.INCS45e = this.stripCommas(row.INCS45e);
          this.INCS45f = this.stripCommas(row.INCS45f);
          this.INCS45g = this.stripCommas(row.INCS45g);
          this.INCS45h = this.stripCommas(row.INCS45h);
          this.INCS45i = this.stripCommas(row.INCS45i);
          this.INCS45j = this.stripCommas(row.INCS45j);
          this.INCS45k = this.stripCommas(row.INCS45k);
          this.INCS45l = this.stripCommas(row.INCS45l);
          this.INCS45m = this.stripCommas(row.INCS45m);
          this.INCS45 = this.stripCommas(row.INCS45);
          this.INCS46a_i = this.stripCommas(row.INCS46a_i);
          this.INCS46a_ii = this.stripCommas(row.INCS46a_ii);
          this.INCS46a = this.stripCommas(row.INCS46a);
          this.INCS46b = this.stripCommas(row.INCS46b);
          this.INCS46c = this.stripCommas(row.INCS46c);
          this.INCS46d_i = this.stripCommas(row.INCS46d_i);
          this.INCS46d_ii = this.stripCommas(row.INCS46d_ii);
          this.INCS46d = this.stripCommas(row.INCS46d);
          this.INCS46e = this.stripCommas(row.INCS46e);
          this.INCS46f = this.stripCommas(row.INCS46f);
          this.INCS46 = this.stripCommas(row.INCS46);
          this.INCS05 = this.stripCommas(row.INCS05);

          // this.INCS06 = row.INCS06;
      },
      kiraINCS06(){
        var total = 0;
        total = Number(this.INCS05) - Number(this.TP73) 
        this.INCS06 = total;
      },
      kiraTempoh(){
        
        var d1 = new Date(this.dateMula);
        var d2 = new Date(this.dateTamat);
        
        var months;
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth();
        months += d2.getMonth();
        this.M = months;
      },
     
      goTo(){
 
        if(this.KL.id == 1){
          this.$router.push({name: "JRB1off"});
        }else{
          this.$router.push({name: "ringkasanMaklumatIR"});
        }
      }
    },
    watch:{ 
       dataJRBpindahan(){
      if(this.dataJRBpindahan.length > 0){
        this.butangSimpan = true;
        this.butangKemaskini = false;
      }else{
        this.butangSimpan = false;
        this.butangKemaskini = true;
      }
    }
      
    },

  computed:{
    INCS46: function(){
      var total = 0;
        total = Number(total) + Number(this.INCS46a)  + Number(this.INCS46b) + Number(this.INCS46c)  + Number(this.INCS46d)
        + Number(this.INCS46e)  + Number(this.INCS46f)  ;
      return total;
    },
     INCS05: function(){
      var total = 0;
        total = Number(total) + Number(this.INCS41)  + Number(this.INCS42) + Number(this.INCS43)  + Number(this.INCS44)
        + Number(this.INCS45)  + Number(this.INCS46)  ;
      return total;
    },
    INCS45: function(){
      var total = 0;
        total = Number(total) + Number(this.INCS45a)  + Number(this.INCS45b) + Number(this.INCS45c)  + Number(this.INCS45d)
        + Number(this.INCS45e)  + Number(this.INCS45f) + Number(this.INCS45g)  + Number(this.INCS45h)
        + Number(this.INCS45i)  + Number(this.INCS45j) + Number(this.INCS45k) + Number(this.INCS45l) + Number(this.INCS45m) ;
      return total;
    },
    INCS41: function(){
      var total = 0;
        total = Number(total) + Number(this.INCS41a)  + Number(this.INCS41b);
      return total;
    },
    INCS46a: function(){
      var total = 0;
        total = Number(total) + Number(this.INCS46a_i)  + Number(this.INCS46a_ii);
      return total;
    },
    INCS46d: function(){
      var total = 0;
        total = Number(total) + Number(this.INCS46d_i)  + Number(this.INCS46d_ii);
      return total;
    },
    // DataJRBpindahan() {
    //   return this.dataJRBpindahan.map(item => ({
    //     ...item,
    //     INCS41a: this.formatNumber(item.INCS41a),
    //     INCS41b: this.formatNumber(item.INCS41b),
    //     INCS41: this.formatNumber(item.INCS41),
    //     INCS42: this.formatNumber(item.INCS42),
    //     INCS43: this.formatNumber(item.INCS43),
    //     INCS44: this.formatNumber(item.INCS44),
    //     INCS45a: this.formatNumber(item.INCS45a),
    //     INCS45b: this.formatNumber(item.INCS45b),
    //     INCS45c: this.formatNumber(item.INCS45c),
    //     INCS45d: this.formatNumber(item.INCS45d),
    //     INCS45e: this.formatNumber(item.INCS45e),
    //     INCS45f: this.formatNumber(item.INCS45f),
    //     INCS45g: this.formatNumber(item.INCS45g),
    //     INCS45h: this.formatNumber(item.INCS45h),
    //     INCS45i: this.formatNumber(item.INCS45i),
    //     INCS45j: this.formatNumber(item.INCS45j),
    //     INCS45k: this.formatNumber(item.INCS45k),
    //     INCS45l: this.formatNumber(item.INCS45l),
    //     INCS45m: this.formatNumber(item.INCS45m),
    //     INCS45: this.formatNumber(item.INCS45),
    //     INCS46a_i: this.formatNumber(item.INCS46a_i),
    //     INCS46a_ii: this.formatNumber(item.INCS46a_ii),
    //     INCS46a: this.formatNumber(item.INCS46a),
    //     INCS46b: this.formatNumber(item.INCS46b),
    //     INCS46c: this.formatNumber(item.INCS46c),
    //     INCS46d_i: this.formatNumber(item.INCS46d_i),
    //     INCS46d_ii: this.formatNumber(item.INCS46d_ii),
    //     INCS46d: this.formatNumber(item.INCS46d),
    //     INCS46e: this.formatNumber(item.INCS46e),
    //     INCS46f: this.formatNumber(item.INCS46f),
    //     INCS46: this.formatNumber(item.INCS46),
    //     INCS05: this.formatNumber(item.INCS05)
    //   }));
    // },
    // INCS06: function () {
    //   var total = 0;
    //   total = Number(this.INCS05) -Number(this.TP73);
    //   return total;
    schemeRule() {
      return schemeRule;
    },
     }
  //},
}
</script>

<style>
#app {
  background: url('~@/assets/HIES.jpg')
  no-repeat center center fixed !important;
  background-size: cover;
}

</style>